import React from 'react';
import {detectIconById} from '../../../../common/enum'
import './table-player.scss';

export const TablePlayer = (props) => {
    const {dataTable} = props;
    return (
        <div className='table-player-container'>
            <h4>{dataTable.title}</h4>
            <table>
                <thead>
                    <tr>
                        <td><p>順位</p></td>
                        <td><p>選手名</p></td>
                        <td><p style={{border: 'unset'}}>{dataTable.value_label}</p></td>
                    </tr>
                </thead>
                <tbody>
                {
                    dataTable.players && dataTable.players.length > 0 && dataTable.players.map(item => {
                        return (<tr>
                            <td>{item.rank}</td>
                            <td style={{textAlign: 'left'}}>
                                <img src={detectIconById(item.player.team.id)} alt=""/>
                                <span>{item.player.player_name_s}</span>
                            </td>
                            <td>{item.value}</td>
                        </tr>)
                    })
                }
                </tbody>
            </table>
        </div>
    );
}